export const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV;
export const APP_URL = process.env.NEXT_PUBLIC_APP_URL;
export const BASE_PATH = '/sign-up';
export const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
export const SITE_COOKIE_DOMAIN = process.env.NEXT_PUBLIC_SITE_COOKIE_DOMAIN;
export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
export const STRIPE_KEY = process.env.NEXT_PUBLIC_STRIPE_KEY;
export const IS_CLIENT = typeof window !== 'undefined';
export const SMARTY_EMBEDDED_KEY = process.env.NEXT_PUBLIC_SMARTY_EMBEDDED_KEY;
export const CONTENTFUL_PREVIEWS_ALLOWED =
  APP_ENV === 'development' || APP_ENV === 'staging';
export const PRODUCT_SERVICE_HOST = process.env.PRODUCT_SERVICE_HOST;
export const PRODUCT_SERVICE_TOKEN = process.env.PRODUCT_SERVICE_TOKEN;
